import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/object-group': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 128C506.6 128 512 122.6 512 116V44C512 37.4 506.6 32 500 32H428C421.4 32 416 37.4 416 44V56H96V44C96 37.4 90.6 32 84 32H12C5.4 32 0 37.4 0 44V116C0 122.6 5.4 128 12 128H24V384H12C5.4 384 0 389.4 0 396V468C0 474.6 5.4 480 12 480H84C90.6 480 96 474.6 96 468V456H416V468C416 474.6 421.4 480 428 480H500C506.6 480 512 474.6 512 468V396C512 389.4 506.6 384 500 384H488V128H500zM448 64H480V96H448V64zM32 64H64V96H32V64zM64 448H32V416H64V448zM480 448H448V416H480V448zM440 384H428C421.4 384 416 389.4 416 396V408H96V396C96 389.4 90.6 384 84 384H72V128H84C90.6 128 96 122.6 96 116V104H416V116C416 122.6 421.4 128 428 128H440V384zM404 192H320V140C320 133.4 314.6 128 308 128H108C101.4 128 96 133.4 96 140V308C96 314.6 101.4 320 108 320H192V372C192 378.6 197.4 384 204 384H404C410.6 384 416 378.6 416 372V204C416 197.4 410.6 192 404 192zM136 168H280V280H136V168zM376 344H232V320H308C314.6 320 320 314.6 320 308V232H376V344z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/object-group.js
// module id = IryS
// module chunks = 144